import { render, staticRenderFns } from "./website.vue?vue&type=template&id=808e2730&scoped=true"
import script from "./website.vue?vue&type=script&lang=js"
export * from "./website.vue?vue&type=script&lang=js"
import style0 from "./website.vue?vue&type=style&index=0&id=808e2730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808e2730",
  null
  
)

export default component.exports